<cb-history-list [entity]="HISTORY_SEARCH_ENTITY.OfferingProduct">
</cb-history-list>
